import { useTranslate } from 'react-polyglot';
import { observer } from 'mobx-react';

import { Tooltip } from '@genially/design-system';

import { usePlayerClientContext } from '../../../../../PlayerClientProvider/hooks/usePlayerClientContext';
import { usePlayerGameContext } from '../../../../PlayerGame.context';
import {
  RaiseHandContainer,
  StyledBasicSubtitle,
  StyledDragAndDropHandIcon,
} from './RaiseHand.styled';

export const RaiseHand = observer(() => {
  const t = useTranslate();
  const { client } = usePlayerClientContext();
  const { raiseHandEnabled, handQueue } = usePlayerGameContext();

  const queuePosition = handQueue.findIndex(p => p.id === client.peerId) + 1;
  const isHandRaised = queuePosition > 0;

  const text = isHandRaised
    ? t('__new.play.view.handsDown')
    : t('__new.play.view.handsUp');

  const handleRaiseHand = () => {
    if (!raiseHandEnabled) return;

    client.sendRaiseHand(!isHandRaised);
  };

  return (
    <Tooltip
      text={text}
      placement={Tooltip.Position.TOP}
      fallbackPlacements={[Tooltip.Position.TOP]}
      renderReferencePortalNode={document.body}
    >
      <RaiseHandContainer
        $active={isHandRaised}
        onClick={handleRaiseHand}
        aria-label={text}
      >
        {isHandRaised && (
          <StyledBasicSubtitle data-cy="queue-position-index">
            {queuePosition}
          </StyledBasicSubtitle>
        )}
        <StyledDragAndDropHandIcon />
      </RaiseHandContainer>
    </Tooltip>
  );
});
